import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";

interface CheckNotificationsProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const CheckNotifications: React.FC<CheckNotificationsProps> = ({
  checked,
  onChange,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ pt: 1, pb: 0 }}
    >
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        sx={{
          padding: 0,
          // pt: 0.2,
          marginRight: 1,
          color: "#ff672d",
          "&.Mui-checked": {
            color: "#ff672d",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      />
      <Typography
        variant="h6"
        sx={{ color: "#ffffff", fontSize: "14px", lineHeight: 1.4 }}
      >
        I agree to receive occasional product updates and promotional emails.
      </Typography>
    </Box>
  );
};

export default CheckNotifications;
